import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { CurvaAbcVendaFilter } from '../../filter';
import { CurvaAbcVendaPerspectiva } from '../../perspectiva';

@Injectable({
    providedIn: 'root'
})
export class CurvaAbcVendaFilterService {
    /** Realiza a consulta da curva abc de vendas */
    createHttpParams(perspectiva: CurvaAbcVendaPerspectiva, filter: CurvaAbcVendaFilter, orderBy: number, orderByDir: string): HttpParams {
        // Params
        let params = new HttpParams()
                        .append('perspectiva', perspectiva?.id.toString() ?? null);

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                        .append('orderByDir', orderByDir ? orderByDir : '');

        return params;
    }
}
